import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, QueryList, ViewChildren } from '@angular/core';
import { ScoreDetailService } from '@core/score-detail.service';
import { IPrintableReportHeading } from '@models/report-print-heading';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalTemplateComponent } from '@shared/modals/modal-template/modal-template.component';
import { ScoreDetailViewComponent } from '@shared/score-detail/score-detail-view/score-detail-view.component';
import { ZbpDataTable } from '@shared/zbp-data-table/zbp-data-table.model';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';
import { IPrintAllScoreDetailsParams } from '../score-detail-modal/score-detail-params';


interface StudentScoreDetailViewModel {
  studentName: string;
  className: string;
  productName: string;
  activityName: string;
  columns: ZbpDataTable.Column[];
  rows: ZbpDataTable.Row[];
  printableHeaders: IPrintableReportHeading[];
}

@Component({
  selector: 'zbp-score-detail-print-all-modal',
  templateUrl: './score-detail-print-all-modal.component.html',
  styleUrls: ['./score-detail-print-all-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ModalTemplateComponent,
    ScoreDetailViewComponent,
  ],
})
export class ScoreDetailPrintAllModalComponent implements AfterViewInit {
  zbpIconNames = zbpIconNames;
  studentViewModels: StudentScoreDetailViewModel[] = [];

  params: IPrintAllScoreDetailsParams;

  @ViewChildren(ScoreDetailViewComponent) scoreDetailViews!: QueryList<ScoreDetailViewComponent>;

  constructor(
    private activeModal: NgbActiveModal,
    private scoreDetailService: ScoreDetailService,
  ) { }

  ngAfterViewInit(): void {
    this.print();
  }

  public static open(ngbModal: NgbModal, params: IPrintAllScoreDetailsParams): NgbModalRef {
    const modal = ngbModal.open(
      ScoreDetailPrintAllModalComponent,
      {
        size: 'lg',
      },
    );
    const component = modal.componentInstance as ScoreDetailPrintAllModalComponent;
    component.params = params;
    component.buildViewModels(params);
    return modal;
  }

  buildViewModels(params: IPrintAllScoreDetailsParams): void {
    this.params = params;
    this.params.students.forEach((student) => {
      /** Parts are not expanded, so we do not need to get the manually scored parts. */
      const vm = this.scoreDetailService.buildTable({
        topicType: this.params.topicType,
        score: student.score,
        benchmark: student.benchmark,
        parts: student.parts,
        isEditing: false,
        productType: this.params.productType,
        manualScoreResponse: null,
      });

      const printableHeaders: IPrintableReportHeading[] = [
        { label: 'Student', value: student.studentName },
        { label: 'Class', value: this.params.className },
        { label: 'Report', value: 'Score Detail' },
        { label: 'Product', value: this.params.productName },
        { label: 'Activity', value: this.params.activityName },
      ];

      this.studentViewModels.push(
        {
          studentName: student.studentName,
          className: this.params.className,
          productName: this.params.productName,
          activityName: this.params.activityName,
          columns: vm.columns,
          rows: vm.rows,
          printableHeaders,
        }
      );
    });
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

  print(): void {
    setTimeout(() => {
      window.print();
      // Modal closes immediately after print.
      this.activeModal.dismiss();
    }, 100);
  }
}
